import {HttpBackend} from '@angular/common/http';
import {registerLocaleData} from "@angular/common";
import localeBg from '@angular/common/locales/bg';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeHr from '@angular/common/locales/hr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeLt from '@angular/common/locales/lt';
import localeLv from '@angular/common/locales/lv';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeSk from '@angular/common/locales/sk';
import localeSl from '@angular/common/locales/sl';
import localeSv from '@angular/common/locales/sv';
import localeTr from '@angular/common/locales/tr';
import localeUk from '@angular/common/locales/uk';
import localeZh from '@angular/common/locales/zh';
import {MultiTranslateHttpLoader} from "ngx-translate-multi-http-loader";
import {KeyOnlyTranslateLoader} from "./core/services/key-only-translate-loader";

registerLocaleData(localeBg);
registerLocaleData(localeCs);
registerLocaleData(localeDa);
registerLocaleData(localeDe);
registerLocaleData(localeEn);
registerLocaleData(localeEs);
registerLocaleData(localeFi);
registerLocaleData(localeFr);
registerLocaleData(localeHr);
registerLocaleData(localeHu);
registerLocaleData(localeIt);
registerLocaleData(localeLt);
registerLocaleData(localeLv);
registerLocaleData(localeNl);
registerLocaleData(localePl);
registerLocaleData(localeRo);
registerLocaleData(localeRu);
registerLocaleData(localeSk);
registerLocaleData(localeSl);
registerLocaleData(localeSv);
registerLocaleData(localeTr);
registerLocaleData(localeUk);
registerLocaleData(localeZh);

export function createTranslateLoader(http: HttpBackend) {
  if (window.location.href.includes("showTranslationKeys=true")) return new KeyOnlyTranslateLoader();
  return new MultiTranslateHttpLoader(http, [
    // appointment booking assets
    {
      prefix: 'https://api.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/0fd2ecb9fe1a179e5f168a9b4e4cb742/locales/',
      suffix: '/download?file_format=simple_json'
    },
    // @vi-succ/design-system-web assets
    {
      prefix: 'https://api.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/ec38b083a23c58c604a49d7f443dd7f2/locales/',
      suffix: '/download?file_format=simple_json'
    }
  ]);
}


